<!-- https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/ -->
<!--
    Usage:

    <TransitionExpand>
        <div v-if="..."></div>
    </TransitionExpand>

    When component is added / removed from DOM our wrapper component,
    will animate height
-->
<template>
    <Transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
        <slot />
    </Transition>
</template>

<script lang="ts" setup>
const enter = (element: Element) => {
    const width = getComputedStyle(element).width;
    const el = element as HTMLElement;

    el.style.width = width;
    el.style.position = "absolute";
    el.style.visibility = "hidden";
    el.style.height = null;

    const height = getComputedStyle(element).height;

    el.style.width = null;
    el.style.position = null;
    el.style.visibility = null;
    el.style.height = "0";

    getComputedStyle(element).height;

    requestAnimationFrame(() => {
        el.style.height = height;
    });
};

const afterEnter = (element: Element) => {
    const el = element as HTMLElement;
    el.style.height = null;
};

const leave = (element: Element) => {
    const height = getComputedStyle(element).height;
    const el = element as HTMLElement;

    el.style.height = height;

    getComputedStyle(element).height;

    requestAnimationFrame(() => {
        el.style.height = "0";
    });
};
</script>

<style lang="scss" scoped>
// Trigger hardware acceleration
* {
    will-change: height;
    backface-visibility: hidden;
}

.expand-enter-active,
.expand-leave-active {
    overflow: hidden;
    transition: height 300ms ease-in-out;
}

.expand-enter,
.expand-leave-to {
    height: 0;
}
</style>
